/**
 * Combine all reducers in this file and export the combined reducers.
 */

//layouts

export default {};
